import { ReactNode, JSX } from 'react';

export const ConditionalWrapper = <T extends ReactNode>(props: {
  condition: boolean;
  wrapper: (child: T) => ReactNode;
  fallbackWrapper?: (child: T) => ReactNode;
  children: T;
}): JSX.Element => {
  return props.condition ? (
    <>{props.wrapper(props.children)}</>
  ) : (
    <>
      {props.fallbackWrapper
        ? props.fallbackWrapper(props.children)
        : props.children}
    </>
  );
};
